export const spacing = (factor: number) =>
    [0, 4, 8, 16, 24, 32, 48, 64, 80, 104][factor];
